import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import './Reviews.css';
import { Grid } from '@mui/material';
import Images from '../../assets/images';

const Reviews = () => {
  const { t } = useTranslation();
  const reviews = useMemo(() => t('reviews.items', { returnObjects: true }) || [], [t]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState('next');
  const [isPaused, setIsPaused] = useState(false);

  const changeReview = useCallback((step) => {
    if (!reviews.length || isAnimating) {
      return;
    }

    setDirection(step > 0 ? 'next' : 'prev');
    setIsAnimating(true);

    setTimeout(() => {
      setActiveIndex((prev) => (prev + step + reviews.length) % reviews.length);
      setIsAnimating(false);
    }, 170);
  }, [reviews.length, isAnimating]);

  useEffect(() => {
    if (!reviews.length || isPaused) {
      return;
    }

    const intervalId = setInterval(() => {
      changeReview(1);
    }, 5500);

    return () => clearInterval(intervalId);
  }, [reviews.length, isPaused, changeReview]);

  const currentReview = reviews[activeIndex] || {};
  const stars = Number(currentReview.rating) || 5;

  return (
    <div className='reviews'>
      <Grid container className='body'>
        <Grid container item xs={12} md={5} className='left desktop'>
          <div className='imageCard'>
            <img className='image1' src={Images.tiim.reviews} alt='Happy customers using Tiim School' />
          </div>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          className='right'
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <label>{t('reviews.label')}</label>
          <h1>{t('reviews.title')} <span>{t('reviews.title2')}</span></h1>
          <div className='imageCard mobile'>
            <img className='image1' src={Images.tiim.reviews} alt='Happy customers using Tiim School' />
          </div>
          <div className={`reviewContent ${isAnimating ? `isChanging ${direction}` : 'isVisible'}`}>
            <div className='stars' aria-label={`${stars} stars`}>
              {Array.from({ length: stars }).map((_, index) => (
                <span key={index}>★</span>
              ))}
            </div>
            <p className='quote'>{currentReview.description}</p>
            <h3>{currentReview.name}</h3>
            <h4>{currentReview.location}</h4>
          </div>

          <div className='controls'>
            <button
              type='button'
              className='navButton navButtonSecondary'
              onClick={() => changeReview(-1)}
              aria-label={t('reviews.prevLabel')}
            >
              <img className='prev' src={Images.icons.arrowRight} alt='Happy customers using Tiim School' />
            </button>
            <button
              type='button'
              className='navButton navButtonPrimary'
              onClick={() => changeReview(1)}
              aria-label={t('reviews.nextLabel')}
            >
              <img className='next' src={Images.icons.arrowRight} alt='Happy customers using Tiim School' />
            </button>
          </div>
        </Grid>
      </Grid>
    </div>

  )
}

export default Reviews 